"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _constants = require("@ahmdigital/constants");
var _formatDate = _interopRequireDefault(require("../../utils/format-date"));
var _getTermsHref = _interopRequireDefault(require("../../shared/get-terms-href"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getOfferEndSummary = function getOfferEndSummary(offer) {
  var _offer$release, _offer$identifier;
  if ((0, _fp.isNil)(offer)) return null;
  var offerEndDate = offer === null || offer === void 0 || (_offer$release = offer.release) === null || _offer$release === void 0 ? void 0 : _offer$release.endTime;
  var cta = offer === null || offer === void 0 ? void 0 : offer.detailsTeaser;
  var offerIdentifier = offer === null || offer === void 0 || (_offer$identifier = offer.identifier) === null || _offer$identifier === void 0 ? void 0 : _offer$identifier.current;
  var targetsSegments = offer === null || offer === void 0 ? void 0 : offer.targetsSegments;
  var isPartnerOffer = (0, _fp.some)(function (segment) {
    var _segment$identifier;
    return (segment === null || segment === void 0 || (_segment$identifier = segment.identifier) === null || _segment$identifier === void 0 ? void 0 : _segment$identifier.current) === _constants.TARGET_SEGMENT.PARTNER_LOOKING_FOR_PRIVATE_HEALTH_INSURANCE;
  }, targetsSegments);
  return {
    value: (0, _fp.compact)([offerEndDate && {
      value: "Offer ends ".concat((0, _formatDate["default"])(offerEndDate, {
        composition: 'd MMM yyyy'
      }), ".")
    }, offerEndDate && cta && {
      value: ' '
    }, cta && {
      value: cta,
      marks: [_objectSpread(_objectSpread({}, isPartnerOffer && {
        inNewTab: true
      }), {}, {
        href: (0, _getTermsHref["default"])(offerIdentifier, isPartnerOffer),
        type: 'link'
      })]
    }])
  };
};
var _default = exports["default"] = getOfferEndSummary;
module.exports = exports.default;